var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"small":"","color":"warning","loading":_setup.generatingPdf,"text":_vm.single === true},on:{"click":_setup.generatePdf}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":"fas fa-file-export"}}),_vm._v(_vm._s(_vm.single ? 'Transport Export' : 'Export for Booyong'))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }